import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router";

import { getErrorMessage } from "helpers";
import {
  getReview,
  Review,
  initialReview,
  putReview,
  postReview,
  deleteReview,
  publishReview,
} from "services/reviews";
import { Image } from "services/images";

export const useReviewPage = (id: number) => {
  const history = useHistory();
  const [formData, setFormData] = useState<Review>(initialReview);

  // Fetch data
  useEffect(() => {
    (async () => {
      if (id > 0) {
        try {
          const data = await getReview(id);
          setFormData(data);
        } catch (e) {
          toast.error(getErrorMessage(e));
          console.error(e);
        }
      }
    })();
  }, [id]);

  const inputChanged = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const name = e.target.name;
    const value = e.target.value;

    setFormData((old) => ({ ...old, [name]: value }));
  };

  const onFileChange = (image: Image | null) => {
    setFormData((old) => ({ ...old, image }));
  };

  const onRichTextChange = (value: string, name: string) => {
    setFormData((old) => ({ ...old, [name]: value }));
  };

  const onFormSave = async (ev: React.MouseEvent<HTMLButtonElement>) => {
    ev.preventDefault();

    // POST
    if (formData.id < 0) {
      try {
        const newReview = await postReview(formData);
        history.push(`/reviews/${newReview.id}`);
        toast.success("Review saved.");
      } catch (e) {
        toast.error(getErrorMessage(e));
        console.error(e);
      }
      return;
    }

    // PUT
    try {
      const newReview = await putReview(formData);
      setFormData(newReview);
      toast.success("Review saved.");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  const onPublishClick = async () => {
    try {
      const newReview = await publishReview(formData.id, !formData.published);
      setFormData(newReview);
      toast.success("Review published.");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  const onDeleteReview = async () => {
    try {
      await deleteReview(id);
      toast.success("Review deleted.");
      history.push("/reviews");
    } catch (e) {
      toast.error(getErrorMessage(e));
      console.error(e);
    }
  };

  return {
    formData,
    onDeleteReview,
    inputChanged,
    onFileChange,
    onFormSave,
    onRichTextChange,
    onPublishClick,
  };
};
